import { SplitButton } from './SplitButton'
import type { Props as SplitButtonProps } from './SplitButton'

const SplitButtonComponent = SplitButton

export { SplitButtonProps }

export default SplitButtonComponent
